import { createSlice } from "@reduxjs/toolkit";
import { ContatoPessoaModel } from "../../../models/contatoPessoa/contatoPessoaModel";
import { TipoContatoPessoaModel } from "../../../models/contatoPessoa/tipoContatoPessoaModel";
import { buscarContatoPessoa, listarTipoContatoPessoa } from "../../../services/contatoPessoaService";
import { resetAll } from "../../actions/actions";
export interface ContatoPessoaState {
  //buscar contato pessoa
  loading: boolean;
  list: ContatoPessoaModel[];
  entity: ContatoPessoaModel;
  //buscar tipo contato pessoa
  loadingTipo: boolean;
  listTipo: TipoContatoPessoaModel[];
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
}

const initialState: ContatoPessoaState = {
  //buscar contato pessoa
  loading: false,
  list: [],
  entity: {} as ContatoPessoaModel,
  //buscar tipo contato pessoa
  loadingTipo: false,
  listTipo: [],
  //internal
  modalCadastrar: false,
  modalDeletar: false,
};

export const contatoPessoaSlice = createSlice({
  name: "contatoPessoa",
  initialState,
  reducers: {
    //buscar contato pessoa
    setEntityContatoPessoa: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalCadastrarContatoPessoa: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarContatoPessoa: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar contato pessoa
    builder.addCase(buscarContatoPessoa.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarContatoPessoa.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarContatoPessoa.rejected, (state, action) => {
      state.loading = false;
    });

    //listar tipo
    builder.addCase(listarTipoContatoPessoa.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(listarTipoContatoPessoa.fulfilled, (state, action) => {
      state.listTipo = action.payload;
      state.loading = false;
    });
    builder.addCase(listarTipoContatoPessoa.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar contato pessoa
  setEntityContatoPessoa,
  //internal
  setModalCadastrarContatoPessoa,
  setModalDeletarContatoPessoa,
} = contatoPessoaSlice.actions;

export default contatoPessoaSlice.reducer;
